import FormattedMessage from 'I18n/components/FormattedMessage';
import { FullScreenPanel } from '../FullScreenPanel';
import { Text } from 'foundations-components/components/Text';
import { useCatalogOptions } from './hooks/useCatalogOptions';
import { List } from 'foundations-components/transitional/components/List';
import { Flex } from 'foundations-components/components/Flex';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/components/View';
import { Fragment, useState } from 'react';
import { LeftIcon } from 'foundations-assets/icons/components/LeftIcon';
import { RightIcon } from 'foundations-assets/icons/components/RightIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CatalogPanel = ({
  isOpen,
  onRemoveButtonClick
}) => {
  const options = useCatalogOptions();
  const [childOption, setChildOption] = useState(null);
  const renderOption = (option, index) => {
    const {
      label,
      options: childOptions,
      onClick
    } = option;
    if (!childOptions && !onClick) {
      return index > 0 ? /*#__PURE__*/_jsx(View, {
        paddingBlockStart: "200",
        children: label
      }, index) : /*#__PURE__*/_jsx(Fragment, {
        children: label
      }, index);
    }
    if (childOptions && childOptions.length > 0) {
      return /*#__PURE__*/_jsx(Button, {
        onClick: () => {
          setChildOption(option);
        },
        use: "unstyled",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          justifyContent: "space-between",
          inlineSize: "100%",
          children: [label, /*#__PURE__*/_jsx(IconHolder, {
            icon: RightIcon,
            padding: "0"
          })]
        })
      }, index);
    }
    return /*#__PURE__*/_jsx(Button, {
      onClick: () => {
        onClick === null || onClick === void 0 || onClick();
        setChildOption(null);
        onRemoveButtonClick();
      },
      use: "unstyled",
      children: /*#__PURE__*/_jsx(View, {
        inlineSize: "100%",
        textAlign: "start",
        children: label
      })
    }, index);
  };
  return /*#__PURE__*/_jsx(FullScreenPanel, {
    isOpen: isOpen,
    onRemoveButtonClick: () => {
      setChildOption(null);
      onRemoveButtonClick();
    },
    title: /*#__PURE__*/_jsx(View, {
      paddingInlineStart: "600",
      children: childOption ? /*#__PURE__*/_jsx(Button, {
        onClick: () => {
          setChildOption(null);
        },
        use: "unstyled",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(IconHolder, {
            icon: LeftIcon,
            paddingInlineStart: "0"
          }), /*#__PURE__*/_jsx(Text, {
            typography: "heading-25",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academy-navigation-lib.ACPage.header.catalogDropdown.backButtonText"
            })
          })]
        })
      }) : /*#__PURE__*/_jsx(Text, {
        typography: "heading-300",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.header.catalogDropdown.buttonText"
        })
      })
    }),
    children: /*#__PURE__*/_jsx(List, {
      childStyles: {
        marginBlockStart: '400'
      },
      firstChildStyles: {
        marginBlockStart: '0'
      },
      wrapChildren: true,
      children: childOption ? [{
        label: /*#__PURE__*/_jsx(Text, {
          typography: "heading-50",
          children: childOption.label
        })
      }, ...childOption.options].map((option, index) => {
        return renderOption(option, index);
      }) : options.map((option, index) => {
        return renderOption(option, index);
      })
    })
  });
};